<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div class="filter">
            <el-form
              :inline="true"
              :model="filter"
              ref="filterForm"
              label-position="right"
              label-width="80px"
              class="search-form"
              size="small"
            >
              <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
                <stockroom-select
                  :val="filter.stockroom_id"
                  @change="filter.stockroom_id = $event"
                ></stockroom-select>
              </el-form-item>
              <el-form-item label="关键字" prop="query">
                <el-input
                  v-model="filter.query"
                  placeholder="序列号，型号，零件号"
                ></el-input>
              </el-form-item>
              <el-form-item label="钻头类型" prop="drill_type">
                <el-select v-model="filter.drill_type">
                  <el-option
                    v-for="(value, index) in DrillTypeMap"
                    :key="index"
                    :label="value"
                    :value="parseInt(index)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="入库类型"
                prop="stock_in_category"
                v-if="status != 3"
              >
                <el-select v-model="filter.stock_in_category">
                  <el-option
                    v-for="(value, index) in DrillStockInCategoryMap"
                    :key="index"
                    :label="value"
                    :value="parseInt(index)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="出库类型"
                prop="stock_out_category"
                v-if="status == 3"
              >
                <el-select v-model="filter.stock_out_category">
                  <el-option
                    v-for="(value, index) in DrillStockOutCategoryMap"
                    :key="index"
                    :label="value"
                    :value="parseInt(index)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="status == 1 ? '入库时间' : '出库时间'"
                prop="date"
                v-show="status == 1 || status == 3"
              >
                <el-date-picker
                  clearable
                  v-model="filter.date"
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <br />
              <el-form-item
                label="查询范围"
                prop="all_stockroom"
                v-if="admin && status == 1"
              >
                <el-checkbox v-model="filter.all_stockroom"
                  >所有仓库</el-checkbox
                >
              </el-form-item>
            </el-form>
            <div style="margin-left: 80px">
              <el-button
                type="primary"
                size="small"
                @click="
                  page = 1
                  getData()
                "
                >筛选</el-button
              >
              <el-button size="small" @click="reset()">重置</el-button>
            </div>
          </div>
        </div>

        <div class="panel">
          <el-button
            type="primary"
            v-if="$route.meta.en_name == 'stock_drill_in' && admin"
            @click.native="formerVisible = true"
            v-code="51102"
            >添加{{ $route.meta.name }}</el-button
          >
          <item-table
            :items="items.list"
            :filter="filter"
            :status="status"
            v-loading="loading"
            :isGeneralStockroom="is_general_stockroom"
            @stockOut="reset"
          ></item-table>
          <el-pagination
            background
            class="m-t-20 text-right"
            :page-size="20"
            :current-page.sync="page"
            @current-change="getData()"
            layout="total, prev, pager, next"
            :total="items.count"
          ></el-pagination>
        </div>
      </div>
    </div>
    <drill-former
      :model="model"
      :show.sync="formerVisible"
      :isGeneralStockroom="is_general_stockroom"
      @created="createdCallback"
    ></drill-former>
  </div>
</template>

<script>
import { drillRecordList } from '@/service/getData'
import ItemTable from './table'
import DrillFormer from '@/components/drill_in_former'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'
import {
  DrillTypeMap,
  DrillStockInCategoryMap,
  DrillStockOutCategoryMap,
} from '@/config/global'

export default {
  components: {
    ItemTable,
    DrillFormer,
    StockroomSelect,
  },
  data() {
    return {
      loading: false,
      DrillTypeMap,
      DrillStockInCategoryMap,
      DrillStockOutCategoryMap,
      admin: getStore('userInfo').is_stockroom_admin,
      filter: {
        stockroom_id: '',
        drill_type: '',
        stock_in_category: '',
        stock_out_category: '',
        date: '',
        query: '',
        all_stockroom: false,
        status: 1,
      },
      model: {
        serial_number: '',
        is_new: '',
        drill_type: '',
        model_number: '',
        component_number: '',
        specification: '',
        package_type: '',
        drill_id: '',
        stock_in_category: '',
        stage: '',
        stock_in_remark: '',
      },
      formerVisible: false,
      status: 1,
      page: 1,
      items: {
        list: [],
        count: 0,
      },
      is_general_stockroom: false,
    }
  },
  watch: {
    $route: function () {
      this.reset()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.page = 1
      this.getData()
    },
    async getData() {
      if (this.$route.meta.en_name == 'stock_drill') {
        this.status = 1
        this.filter.status = 1
      } else if (this.$route.meta.en_name == 'stock_drill_in') {
        this.status = 0
        this.filter.status = 0
      } else if (this.$route.meta.en_name == 'stock_drill_out') {
        this.status = 3
        this.filter.status = 3
      }
      let data = {
        page: this.page - 1,
        size: 20,
        status: this.status,
        stockroom_id: this.filter.stockroom_id,
        drill_type: this.filter.drill_type,
        stock_in_category: this.filter.stock_in_category,
        stock_out_category: this.filter.stock_out_category,
        query: this.filter.query,
        all_stockroom: this.filter.all_stockroom,
      }

      if (this.filter.date && this.filter.date.length == 2) {
        data.start_date = this.filter.date[0]
        data.end_date = this.filter.date[1]
      }

      this.loading = true
      let res = await drillRecordList(data)
      this.is_general_stockroom = res.data.is_general_stockroom
      this.items = res.data
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
    createdCallback(item) {
      this.items.list.unshift(item)
    },
  },
}
</script>